var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VLayout',{attrs:{"title":_vm.$t('contract.title')}},[_c('VMarkdownView',{attrs:{"mdtext":_vm.$t('contract.legal_text')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }